import CustomCollapse from '../../../../../../v2-components/Antd/Collapse';
import CustomPanel from '../../../../../../v2-components/Antd/Panel';
import { renderApprovalHistory } from './render-approval-history.handle';
import { renderRejectionHistory } from './render-rejection-history.handle';

export const rejectHistoryAdapter = (history, qfHistory) => {
	if (history?.length > 0 || qfHistory?.length > 0) {
		return (
			<CustomCollapse accordion>
				<CustomPanel key={1} header={`Historial de rechazos`} style={{ marginBottom: '20px' }}>
					{history?.length > 0 ? renderRejectionHistory(history) : 'No hay registro de rechazos'}
				</CustomPanel>
				<CustomPanel key={2} header={'Historial de aprobaciones bajo criterio del farmacéutico'} style={{ marginBottom: '20px' }}>
					{qfHistory?.length > 0 ? renderApprovalHistory(qfHistory) : 'No hay registro de aprobaciones por QF'}
				</CustomPanel>
			</CustomCollapse>
		);
	}

	return <h6>Aún no tienen aprobaciones o rechazos de receta para este producto</h6>;
};
